// FetchOffersOverview POST /api/2.0/offers/fetch_offers_overview
import { api } from "services/api/service";
import { API_BULK_OFFER_ISSUANCE_CHANGE_STATUS, API_BULK_OFFER_ISSUANCE_DRAFT_LIST, API_BULK_OFFER_ISSUANCE_DOWNLOAD } from "constants/api";
import type { ApiResponse } from "services/api/types";

interface bulkOfferDraftListPayload {
	status?: string[];
	page_number?: string;
	page_records?: string;
}

interface bulkOfferIssuanceCancelPayload {
	draft_id: number;
	next_status: "APPROVED" | "REJECTED" | "CANCELLED";
	reject_reason?: string;
}

interface bulkOfferIssuanceDownloadPayload {
	draft_id: number;
	file_type?: "input" | "success" | "error";
}

export const bulkOfferIssuanceDraftList = async (payload: bulkOfferDraftListPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_BULK_OFFER_ISSUANCE_DRAFT_LIST, payload);
};

export const bulkOfferIssuanceChangeStatus = async (payload: bulkOfferIssuanceCancelPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_BULK_OFFER_ISSUANCE_CHANGE_STATUS, payload);
};

export const bulkOfferIssuanceDownload = async (payload: bulkOfferIssuanceDownloadPayload): Promise<ApiResponse<any>> => {
	return (await api()).post(API_BULK_OFFER_ISSUANCE_DOWNLOAD, payload);
};
